<template>
  <el-tabs type="border-card">
    <my-power-station-one :beg="beg" />
    <!-- <el-tab-pane label="电站列表(分组显示)">
    </el-tab-pane>
    <el-tab-pane label="电站统计">
      <my-power-station-two/>
    </el-tab-pane>
    <el-tab-pane label="分组管理">
      <my-power-station-three/>
    </el-tab-pane> -->
  </el-tabs>
</template>

<script>
import MyPowerStationOne from "@/views/PowerStationManage/MyPowerStation/MyPowerStationOne";
// import MyPowerStationTwo from "@/views/PowerStationManage/MyPowerStation/MyPowerStationTwo";
// import MyPowerStationThree from "@/views/PowerStationManage/MyPowerStation/MyPowerStationThree";

export default {
  name: "PowerStationMain",
  components: {
    // MyPowerStationThree,
    // MyPowerStationTwo,
    MyPowerStationOne,
  },
  data() {
    return {
      beg: 0,
    };
  },
  // beforeRouteEnter: function (to, from, next) {
  //   if(from.name=="设备详细"){
  //     //如果是设备详细跳转过来的，通知页面刷新
  //     sessionStorage.setItem('isDetail', 'true');
  //   } else {
  //     sessionStorage.setItem('isDetail', 'false');
  //   }
  //   next(vm => {
  //     from.name !== "设备详细" ?
  //         (vm.beg === -1 ? vm.beg = 1 : vm.beg += 1)
  //         : vm.beg = -1;
  //   })

  // },
  beforeRouteEnter(to, from, next) {
    if (from.name == "设备详细") {
      //如果是设备详细跳转过来的，通知页面
      sessionStorage.setItem("fromDetailParams", "true");
    }
    next();
  },
};
</script>
